
/* Lieblingspyjama — Geschenk ab 80 EUR (sans rechargement de page) */
(function () {
  var GIFT = 53873935810907;   /* Kuschelsocken Rutschfest */
  var MIN  = 8000;             /* 80,00 EUR en centimes */
  var busy = false, last = '';

  function j(url, opts){
    opts = opts || {};
    opts.headers = Object.assign({'Content-Type':'application/json','Accept':'application/json'}, opts.headers||{});
    return fetch(url, opts).then(function(r){ return r.json(); });
  }

  /* redessine le tiroir via l'EventBus du theme, sans recharger */
  function redraw(){
    var bus = window.themeCore && window.themeCore.EventBus;
    if (bus && bus.emit){
      bus.emit('cart:refresh');
      bus.emit('cart:updated');
      return;
    }
    ['cart:refresh','cart:updated'].forEach(function(ev){
      document.dispatchEvent(new CustomEvent(ev, {bubbles:true}));
    });
  }

  function run(){
    if (busy) return;
    busy = true;
    j('/cart.js').then(function(cart){
      var sub = 0, gift = null;
      (cart.items||[]).forEach(function(it){
        if (it.variant_id === GIFT) gift = it; else sub += it.final_line_price;
      });

      /* rien a faire : on n'emet aucun evenement, le panier reste intact */
      var want = sub >= MIN;
      if (want === !!gift && !(gift && gift.quantity > 1)){ busy = false; return; }

      if (want && !gift){
        return j('/cart/add.js', {method:'POST', body: JSON.stringify({id: GIFT, quantity: 1})})
          .then(redraw).then(function(){ busy = false; });
      }
      if (!want && gift){
        var u = {}; u[gift.key] = 0;
        return j('/cart/update.js', {method:'POST', body: JSON.stringify({updates: u})})
          .then(redraw).then(function(){ busy = false; });
      }
      if (gift && gift.quantity > 1){
        var u2 = {}; u2[gift.key] = 1;
        return j('/cart/update.js', {method:'POST', body: JSON.stringify({updates: u2})})
          .then(redraw).then(function(){ busy = false; });
      }
      busy = false;
    }).catch(function(){ busy = false; });
  }

  function boot(){
    run();
    var bus = window.themeCore && window.themeCore.EventBus;
    if (bus && bus.listen){
      bus.listen('cart:updated', function(){ setTimeout(run, 250); });
      bus.listen('cart:drawer:open', function(){ setTimeout(run, 250); });
    }
    ['cart:updated','cart:refresh','cart:change','cart:build'].forEach(function(ev){
      document.addEventListener(ev, function(){ setTimeout(run, 250); });
    });
    setInterval(run, 2500);
  }

  if (window.themeCore && window.themeCore.EventBus) boot();
  else {
    document.addEventListener('theme:all:loaded', boot);
    setTimeout(boot, 1200);
  }
})();
